import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CartIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CartIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 17">
      <path d="M7.8 9.374h9.252a.769.769 0 00.726-.5l2.174-6.025a.757.757 0 00-.095-.694.774.774 0 00-.63-.322H5.318L4.794.487A.77.77 0 004.075 0H.77A.765.765 0 000 .76a.765.765 0 00.77.76h2.777l2.8 7.167-1.1 2.475a.754.754 0 00.06.723.773.773 0 00.645.344H17.99a.76.76 0 100-1.52H7.123l.6-1.351a.641.641 0 00.077.016zM5.911 3.349h12.227l-1.626 4.5H7.8a.728.728 0 00-.125.025z" />
      <ellipse
        cx={2.054}
        cy={2.027}
        rx={2.054}
        ry={2.027}
        transform="translate(5.565 12.946)"
        fill="none"
      />
      <path d="M7.619 12.946a2.027 2.027 0 102.054 2.027 2.043 2.043 0 00-2.054-2.027zm0 2.534a.507.507 0 11.514-.507.512.512 0 01-.514.507z" />
      <ellipse
        cx={2.054}
        cy={2.027}
        rx={2.054}
        ry={2.027}
        transform="translate(13.782 12.946)"
        fill="none"
      />
      <path d="M15.836 12.946a2.027 2.027 0 102.054 2.027 2.042 2.042 0 00-2.054-2.027zm0 2.534a.507.507 0 11.513-.507.512.512 0 01-.513.507z" />
    </Icon>
  )
}
export default CartIcon
